import { Button, Modal } from "antd";
import { ContainerButton } from "../styles";

const actionButtons = [
  { key: "7", label: "Anúncio de Venda" },
  { key: "1", label: "Detalhes" },
  { key: "2", label: "Ver Períodos" },
  { key: "3", label: "Representante" },
  { key: "4", label: "Meus Documentos" },
  { key: "5", label: "Informações Úteis" },
  { key: "6", label: "Excluir" },
];

// Mantém as ações implementadas no onClick, mas as oculta temporariamente da interface.
const hiddenActionKeys = ["1", "3", "6"];

export default function ModalAcoes({
  isModalOpen,
  handleFechar,
  onClick,
  cotaUsuarioId,
  numeroCota,
  empreend,
  status,
  usuarioLogadoId,
  selectedRowKeys,
  emLote,
}: any) {
  const handleButtonClick = (key: string) => {
    const params: any = { key };

    switch (key) {
      case "1":
        params.cotaUsuarioIdModal = cotaUsuarioId;
        break;
      case "2":
        params.cotaUsuarioIdModal = cotaUsuarioId;
        params.numeroCotaModal = numeroCota;
        params.empreendModal = empreend;
        break;
      case "4":
        params.cotaUsuarioIdModal = cotaUsuarioId;
        break;
      case "5":
        params.empreendModal = empreend;
        break;
      case "7":
        params.cotaUsuarioIdModal = cotaUsuarioId;
        params.usuarioLogadoIdModal = usuarioLogadoId;
        params.empreendModal = empreend;
        break;
    }

    onClick(params);
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title="Ações Disponíveis"
      footer={null}
    >
      <ContainerButton>
        {actionButtons
          .filter((btn) => !hiddenActionKeys.includes(btn.key))
          .map((btn) => (
            <Button
              key={btn.key}
              style={{ margin: "5px 0", width: "100%" }}
              onClick={() => handleButtonClick(btn.key)}
            >
              {btn.label}
            </Button>
          ))}
      </ContainerButton>
    </Modal>
  );
}
